import { Button } from '@progress/kendo-react-buttons';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import './VeevaCaptureBanner.scss';
import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { PROFILE_CAPTURE_ROUTES } from 'routes/routes.const';
import useNavigationMenus from 'common/hooks/useMenus';
import { useParams } from 'react-router-dom';

interface VeevaCaptureBannerProps {
  children: React.ReactNode;
}

function VeevaCaptureBanner({ children }: VeevaCaptureBannerProps) {
  const { compareUrl } = useCompareUrlWithProjectId();
  const { projectId } = useParams();
  const { captureOnly } = useNavigationMenus();

  const displayBanner = compareUrl(PROFILE_CAPTURE_ROUTES.root, { includes: true });
  const displayKwelloButton = !captureOnly;

  // Derived at runtime so the button keeps the user on whichever host is
  // serving the app. It previously used the build-time VITE_AUTH0_APP_ORIGIN,
  // which pinned one build to one hostname. window.location.origin never has a
  // trailing slash, so no trimming is needed.
  const navigateToKwello = () => {
    window.open(`${window.location.origin}/insights/${projectId}`, '_blank');
  };

  return (
    <div className={`veeva-capture-container ${displayBanner ? 'show-banner' : 'hide-banner'}`}>
      {displayBanner && (
        <div className="veeva-capture-banner">
          <div className="veeva-capture-left">
            <KwelloSvgIcon icon={KWELLO_ICON.CAPTURE_MENU_ICON} className="veeva-capture-icon" />
            <div>
              <span className="main-text">Capture-only view.</span>{' '}
              <span className="sub-text">Focused view for recording activities.</span>
            </div>
          </div>
          <div className="veeva-capture-right">
            {displayKwelloButton && (
              <>
                <span className="sub-text">Need full Kwello Insights?</span>
                <Button className="veeva-kwello-button" size="small" onClick={navigateToKwello}>
                  Go to full site
                </Button>
              </>
            )}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}

export default VeevaCaptureBanner;
